(function () {
  document.addEventListener('DOMContentLoaded', init);
  if (document.readyState !== 'loading') init();

  function init() {
    document.querySelectorAll('[data-velisse-reviews]').forEach(setupReviews);
    document.querySelectorAll('[data-velisse-accordion]').forEach(setupAccordion);
    document.querySelectorAll('[data-velisse-video]').forEach(setupVideo);
  }

  function setupReviews(container) {
    if (container.dataset.velisseReady) return;
    container.dataset.velisseReady = 'true';

    const reviews = Array.from(container.querySelectorAll('[data-velisse-review]'));
    const nextBtn = container.querySelector('[data-velisse-reviews-next]');
    if (!nextBtn || reviews.length < 2) return;

    let index = 0;
    nextBtn.addEventListener('click', function () {
      reviews[index].hidden = true;
      index = (index + 1) % reviews.length;
      reviews[index].hidden = false;
    });
  }

  function setupAccordion(item) {
    if (item.dataset.velisseReady) return;
    item.dataset.velisseReady = 'true';

    const trigger = item.querySelector('[data-velisse-accordion-trigger]');
    const panel = item.querySelector('[data-velisse-accordion-panel]');
    if (!trigger || !panel) return;

    function setState(open) {
      item.classList.toggle('is-open', open);
      trigger.setAttribute('aria-expanded', open ? 'true' : 'false');
      panel.style.maxHeight = open ? panel.scrollHeight + 'px' : '0px';
    }

    setState(item.classList.contains('is-open'));

    trigger.addEventListener('click', function () {
      setState(!item.classList.contains('is-open'));
    });

    window.addEventListener('resize', function () {
      if (item.classList.contains('is-open')) {
        panel.style.maxHeight = panel.scrollHeight + 'px';
      }
    });
  }

  function setupVideo(item) {
    if (item.dataset.velisseReady) return;
    item.dataset.velisseReady = 'true';

    const video = item.querySelector('video');
    const playBtn = item.querySelector('[data-velisse-video-play]');
    if (!video || !playBtn) return;

    // Forzamos silencio total: sin audio en ningún caso, aunque el navegador
    // intente restaurar el volumen al reproducir por JS.
    video.muted = true;
    video.volume = 0;
    video.removeAttribute('controls');

    item.addEventListener('click', function () {
      video.muted = true;
      video.volume = 0;
      if (video.paused) {
        video.play();
        item.classList.add('is-playing');
      } else {
        video.pause();
        item.classList.remove('is-playing');
      }
    });

    video.addEventListener('volumechange', function () {
      if (!video.muted || video.volume !== 0) {
        video.muted = true;
        video.volume = 0;
      }
    });

    video.addEventListener('ended', function () {
      item.classList.remove('is-playing');
    });
  }
})();
